import {
  Icons,
  LayoutCard,
  Stack,
  StatusChipV2,
  Typography,
} from '@cast/design-system';

import { useAutoOptimization } from '../../../_hooks/useAutoOptimization';
import { ErrorPanel } from './ErrorPanel';
import { LoadingGeneratingRecommendations } from './LoadingGeneratingRecommendations';
import { ProposedPolicies } from './ProposedPolicies';

export const WorkloadAutoscalerSection = () => {
  const {
    state: { recommendations },
    onGenerate,
  } = useAutoOptimization();

  const isGenerating = recommendations.isLoading || !recommendations.data;

  const headerEndContent = recommendations.error ? (
    <StatusChipV2 label="Error" color="error" />
  ) : isGenerating ? (
    <StatusChipV2 label="Generating" color="neutral" loading />
  ) : (
    <StatusChipV2 label="Ready" color="success" />
  );

  return (
    <LayoutCard
      headerEndContent={headerEndContent}
      title={
        <Stack direction="row" alignItems="center" gap={8}>
          <Icons.CastWorkloadAutoscaler size={20} variant="preset" />
          <Typography variant="h6">Workload autoscaler</Typography>
        </Stack>
      }
      headerDivider
      padding={false}
      slotProps={{
        content: {
          sx: { p: 16 },
        },
      }}
    >
      {recommendations.error ? (
        <ErrorPanel title="Failed to generate policies" onRetry={onGenerate} />
      ) : isGenerating ? (
        <LoadingGeneratingRecommendations
          subtitle="Usually ready in 2–3 minutes"
          phases={[
            {
              label: 'Reading cluster',
              description:
                'Collecting workload definitions, resource requests, and policy assignments.',
            },
            {
              label: 'Profiling workloads',
              description:
                'Identifying risk profiles and sampling 7 days of CPU and memory usage.',
            },
            {
              label: 'Drafting policies',
              description:
                'Generating scaling policies based on your priority and environment settings.',
            },
            {
              label: 'Validating coverage',
              description:
                "Ensuring every workload is assigned and assignment rules don't overlap.",
            },
          ]}
        />
      ) : (
        <ProposedPolicies />
      )}
    </LayoutCard>
  );
};
